import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemDecimalEditor from '../FormItemDecimalEditor';
import FormItemDecimalEditorForDataGrid from '../FormItemDecimalEditorForDataGrid';
import FormItemDecimalRender from '../renders/FormItemDecimalRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';
import {UpdateDropDownContentStore} from '../../stores/CmdTypeStore';

export default class FormItemDecimalEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemDecimalEditorControl";
		this.unsubscribeUpdateDropDownContenStore = UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));

	}




	onUpdateDropDownContnent(type,control,formModuleInstanceuuId)
	{
		if(this.module.instanceUUId == formModuleInstanceuuId && control == this.xml.name)
		{
			this.dropDownContent=type;	
		}
	}
	
	getDefaultDisplayLength()
	{
		return 12;
	}

	getProperty_AutoSum(){
		//return true;
		return this.properties.AutoSum;
	}

	getProperty_NumOfDecimals()
	{
		return this.properties.NumOfDecimals;
	}

	getProperty_AllowNegative()
	{
		if(this.properties.hasOwnProperty("AllowNegative"))
			return this.properties.AllowNegative;
		return true;
	}

	getProperty_RoundOff()
	{
		return this.properties.RoundOff;
	}

	getProperty_ShowZero()
	{
		return this.properties.ShowZero;
	}

	getProperty_ShowDecimals()
	{
		if(this.properties.hasOwnProperty("ShowDecimals"))
			return this.properties.ShowDecimals;
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.DisplayDecimals)
			return displayStyle.DisplayDecimals;
		return this.properties.DisplayDecimals;
	}

	getProperty_ThousandSeperator()
	{
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.ThousandSeperator)
			return displayStyle.ThousandSeperator;
		return this.properties.ThousandSeperator;
	}

	getProperty_DropDownContent()
	{
		return this.properties.DropDownContent;
	}

	getProperty_DisplayStyle()
	{
		if(this._castedDisplayStyle)
			return this._castedDisplayStyle;
		let _displayStyle = this.properties.DisplayStyle;
		try
		{
			_displayStyle = JSON.parse(_displayStyle);
		}
		catch(e)
		{

		}
		this._castedDisplayStyle = _displayStyle;
		return this._castedDisplayStyle;
	}

	getDefaultValue()
	{
		var dvalue = super.getDefaultValue();
		if(dvalue == "")
		{
			var numdecimals = this.getProperty_NumOfDecimals();
			if(numdecimals > 0)
				dvalue = "0.";
			else
				dvalue = "0";
			while(numdecimals>0)
			{
				dvalue += "0";
				numdecimals --;
			}	
		}
		return dvalue;
	}

	getProperty_Alignment()
	{
		let displayStyle = this.getProperty_DisplayStyle();
		if(displayStyle && displayStyle.HorizontalAlignment)
			return displayStyle.HorizontalAlignment;
		if(this.properties.hasOwnProperty("Alignment"))
			return this.properties.Alignment;
		return "Right";
	}

	getComponentInstance(parent,forLookup)
	{
	  let layout = parent.Properties.Layout.Value;
	  let displayLengthWidth = this.getDisplayLengthWidth();
	  let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
	  let commonProps = this.getCommonProps();
	  let displayLength=this.propertyDisplayLength?this.propertyDisplayLength:this.getProperty_DisplayLength();
	  let displayHeight=this.getProperty_DisplayHeight();
	  let notNull=this.propertyNotNull?this.propertyNotNull:this.getProperty_NotNull();
	  let _initRecord = this.record;
	  if(!_initRecord)
	  {
	  	if(!this.group)
	  	{
	  		let defaultValue = this.getDefaultValue();
	  		_initRecord = defaultValue;
	  	}
	  }
      this.component = <FormItemDecimalEditor displayLengthWidth={displayLengthWidth} key={this.xml.id} 
              displayLength={displayLength} displayHeight={displayHeight} notNull={notNull} moduleInstanceId={this.module.instanceUUId}
              xml={this.xml} parentLayout={layout} forLookup={forLookup} formType={EditorFormType.FormModule} 
              underFieldGroup={parent.type=="FieldGroup"} groupAlias={this.groupAlias}
              dataField = {this.getDataField()} initRecord = {_initRecord} displayStyle = {this.getProperty_DisplayStyle()}
              label={label} customStyle={this.getStyle()} formId={this.formId} 
              menuItemId={this.menuItemId} contextMenuData={this.contextMenuData}
              numOfDecimals={this.getProperty_NumOfDecimals()} allowNegative={this.getProperty_AllowNegative()} roundOff={this.getProperty_RoundOff()}
              showZero={this.getProperty_ShowZero()} showDecimals={this.getProperty_ShowDecimals()} thousandSeperator={this.getProperty_ThousandSeperator()}
			  control={this} underQueryGroup={this.isUnderQueryGroup()} verticalAlign={this.getProperty_VAlignment()}
			  cssStyle={this.getProperty_CSSStyle_Display()} {...commonProps}/>;
	  return this.component;
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		return <FormItemDecimalEditorForDataGrid key={this.xml.id} xml={this.xml} forLookup={forLookup} formType={EditorFormType.FormModule} group={this.group} 
				numOfDecimals={this.getProperty_NumOfDecimals()} allowNegative={this.getProperty_AllowNegative()} roundOff={this.getProperty_RoundOff()} 
				control={this} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML}
				verticalAlign={this.getProperty_VAlignment()}/>;
	}


	getRenderForDataGrid(forLookup)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemDecimalRender contextMenuData={this.contextMenuData} group={this.group} dataField = {this.getDataField()} showZero={this.getProperty_ShowZero()} showDecimals={this.getProperty_ShowDecimals()} thousandSeperator={this.getProperty_ThousandSeperator()}
		formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={forLookup} moduleInstanceId={this.module.instanceUUId} displayStyle={displayStyle}
		verticalAlign={this.getProperty_VAlignment()}  cssStyle={this.getProperty_CSSStyle_Display()}/>;
	}

	getRenderForDynamicColumn(dataField)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		return <FormItemDecimalRender contextMenuData={this.contextMenuData} group={this.group} dataField = {dataField} showZero={this.getProperty_ShowZero()} showDecimals={this.getProperty_ShowDecimals()} thousandSeperator={this.getProperty_ThousandSeperator()}
		formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} textAlign={this.getProperty_Alignment()} forLookup={false} moduleInstanceId={this.module.instanceUUId} displayStyle={displayStyle}
		verticalAlign={this.getProperty_VAlignment()}  cssStyle={this.getProperty_CSSStyle_Display()}/>;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemDecimalEditorControl.js